// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__67cgr","clinicsSelect":"styles_clinicsSelect__19HOO"};